/* eslint-disable no-unused-vars */

export enum ConditionOperator {
  Equals,
  NotEqual,
  Contains,
  DoesNotContain,
  ContainsData,
  DoesNotContainData
}
export interface INavigation {
  title: string;
  url: string;
  open_new_window: boolean;
  status?: NavigationStatus;
  children?: INavigation[];
  is_hidden: boolean;
}

export const enum NavigationStatus {
  NotStarted = 0,
  Started = 1,
  Complete = 2
}
